<footer class="pt-3 pb-2">
  <div class="container d-flex justify-content-center text-center">
    @if (copyRight.length > 0) {
      <p>{{ copyRight }}</p>
    }
  </div>
</footer>
